import {UIState} from 'coreStore/data/ui/types';
import createCtx from 'coreUtils/createCtx';

export const [useRefinementsContext, FiltersContextProvider] = createCtx<{
	setIsLoading: (isLoading: boolean) => void;
	searchConfig: UIState['searchConfig'];
}>();
